<template>
  <div class='cve-cvss-score-table-cell'>
    <custom-tooltip placement="right-end" popper-class="light-tooltip">
      <div slot='buttonContent'>
        <div class="cvss-score" :style="style">
          {{ score }}
        </div>
      </div>
      <div slot="content">
        <slot name="tooltip">
          {{ version }}
        </slot>
      </div>
    </custom-tooltip>
  </div>
</template>

<script>
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'CveCvssScoreTableCell',
  components: {CustomTooltip},
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    style() {
      return {
        ...this.color,
        backgroundColor: this.color['background-color'],
        fontSize: '14px',
        width: '37px',
        height: '25px',
        borderRadius: '3px',
      };
    },
    score() {
      return this.item[this.column.field].score && Object.keys(this.item[this.column.field].score).length > 0 && Object.keys(this.item[this.column.field].score)[0] !== 'None'
        ? Object.keys(this.item[this.column.field].score)[0]
        : 0;
    },
    version() {
      return this.item[this.column.field].version ? this.item[this.column.field].version : 'cvss2';
    },
    color() {
      const severity = this.score;
      if (severity >= 9 && severity <= 10) {
        return {color: '#E0255E', 'background-color': '#E0255030'};
      }
      if (severity >= 7 && severity <= 8.9) {
        return {color: '#FF7F00', 'background-color': '#FF7F0030'};
      }
      if (severity >= 4 && severity <= 6.9) {
        return {color: '#2459d5', 'background-color': '#2459d530'};
      }
      return {color: '#2BAF69', 'background-color': '#2BAF6030'};
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.cve-cvss-score-table-cell {
  .cvss-score {
    text-align: center;
    margin-top: $space-4;
    font-family: $font-family-semibold;
    font-size: $font-size-base;
    justify-content: center;
    letter-spacing: 0;
    line-height: rem(16);
    padding: $space-1 $space-1 $space-1 rem(6);
  }
}
</style>
